'use strict';

/**
 * djb2 string hash implementation based on string-hash module:
 * https://github.com/darkskyapp/string-hash
 */

module.exports = function hashStr(str) {
  var hash = 5381;
  var i = str.length;

  while (i) {
    hash = (hash * 33) ^ str.charCodeAt(--i)
  }
  return hash >>> 0;
};



/*****************
 ** WEBPACK FOOTER
 ** ./~/csjs/lib/hash-string.js
 ** module id = 21
 ** module chunks = 0
 **/